<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.school.schoolUpdate') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-text-field
                                :rules="[rules.required]"
                                :label="$vuetify.lang.t('$vuetify.custom.school.schoolName')+'*'"
                                v-model="schoolMsg.name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :rules=nickNameRules
                                :label="$vuetify.lang.t('$vuetify.custom.school.nickName')+'*'"
                                v-model="schoolMsg.nickName"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addUser">{{ $vuetify.lang.t('$vuetify.custom.class.update') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>

    export default {
        name: 'school-update',
        model: {
            prop: 'dialog',
            event: 'parent-event'
        },
        props: {
            dialog: Boolean,
            schoolMsg:Object
        },
        data: () => ({
            rules: {
                required: value => !!value || '请输入'
            },
            nickNameRules:[
                v => !!v || '简称必填',
                v => v.length <= 4 || '简称最长不能超过4个字',
            ],
        }),
        methods: {
            hiddenDialog() {
                this.$emit('initialize')
                this.$emit('parent-event', false);
            },
            addUser() {
                if (this.$refs.form.validate()) {
                    this.$api.school.updateSchool(this.schoolMsg).then(data => {
                      if (data.flag) {
                        this.$dialog.alert("修改成功");
                        this.$emit('initialize')
                        this.hiddenDialog();
                      }else{
                        this.$dialog.alert(data.msg)
                      }
                    })

                }
            }
        },
        components: {
        },
    }
</script>
